
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"23","viewBox":"0 0 22 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11 0.5C4.91333 0.5 0 5.39535 0 11.4598C0 17.5242 4.91333 22.4195 11 22.4195C17.0867 22.4195 22 17.5242 22 11.4598C22 5.39535 17.0867 0.5 11 0.5ZM12.0469 9.54199V17.4378H9.92285V9.54199H12.0469ZM9.79834 7.49871C9.79834 7.18249 9.90332 6.92222 10.1133 6.71789C10.3281 6.51356 10.6187 6.4114 10.9849 6.4114C11.3462 6.4114 11.6343 6.51356 11.8491 6.71789C12.064 6.92222 12.1714 7.18249 12.1714 7.49871C12.1714 7.8198 12.0615 8.08251 11.8418 8.28684C11.627 8.49116 11.3413 8.59333 10.9849 8.59333C10.6284 8.59333 10.3403 8.49116 10.1206 8.28684C9.90576 8.08251 9.79834 7.8198 9.79834 7.49871Z","fill":"#EB5757"}})])
          )
        }
      }
    